/**
 * Function to wait for a cookie in the browser storage, and if the cookie is found, a callback is runned.
 * @param {Array<String>} cookieNamesArray name of the cookie to wait for. Needs to be array of names of the cookies.
 * @param {Number} timeout value in ms, total of time to iterate in checkFrecuency for the cookie
 * @param {Number} frecuencyCheck value in ms, frecuency time to check for the cookie before timeout is reached
 * @param {Boolean} returnAnyway return the values found at the end of the timeout, even if the values are not found. Default false.
 * @param {Function} callback code to run after find the cookie, if the cookie is reached. Recieve as arguments the values of the cookies found (only if all )
 */
export default function waitMultipleCookies(
  cookieNamesArray,
  timeout,
  frecuencyCheck,
  returnAnyway = false,
  callback,
) {
  const cookies = [].concat(cookieNamesArray);
  const values = {};
  const t0 = performance.now();
  const myInterval = setInterval(detectCookie, frecuencyCheck);

  /**
   * Function to detect cookie inside the interval
   */
  function detectCookie() {
    const t1 = performance.now();
    if (t1 - t0 <= timeout) {
      const cookieStorage = new window.proxyStorage.WebStorage('cookieStorage');
      for (let index = 0; index < cookies.length; index += 1) {
        const cookieName = cookies[index];
        const cookieValue = cookieStorage.getItem(cookieName);

        if (cookieValue !== null) {
          values[cookieName] = cookieValue;
        }

        if (Object.keys(values).length === cookieNamesArray.length) {
          clearInterval(myInterval);
          callback(values);
        }
      }
    } else {
      clearInterval(myInterval);
      if (returnAnyway && Object.keys(values).length > 0) {
        callback(values);
      }
    }
  }
}
